<template>
  <div :class="$style.card" class="py-component-padding-2xLarge">
    <slot name="icon">
      <SCASvgIcon v-if="icon" :icon="icon" size="44px" />
    </slot>
    <h1 v-if="title">{{ title }}</h1>
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { IconName } from "@scayla/components";
import { SCASvgIcon } from "@scayla/components";
import { useLogger } from "@scayla/core";

const props = withDefaults(
  defineProps<{
    icon?: IconName;
    title?: string;
  }>(),
  {
    icon: "phosphor/info",
    title: undefined,
  },
);

useLogger("MessageBox").debug("props", props);
</script>

<style module lang="scss">
.card {
  width: 100%;
  max-width: 540px;
  background-color: white;
  text-align: center;

  h1 {
    text-align: center;
    margin-bottom: 24px;
    line-height: 1.33;
  }
}
</style>
